var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwatchesPalette(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 21.001H20.4706C20.763 21.001 21.0002 20.7641 21.0002 20.4717L21 14.5303M7.98047 20.6723L20.6421 14.7681C20.9071 14.6445 21.0217 14.3294 20.8981 14.0645L18.3872 8.68018C18.2636 8.41518 17.9486 8.30012 17.6836 8.42369L12.0303 11.0601M9.88182 18.4058C9.38152 20.2729 7.46235 21.3809 5.59521 20.8806C3.72808 20.3803 2.61982 18.4614 3.12011 16.5942L6.73596 3.09961C6.81163 2.81719 7.10168 2.64952 7.3841 2.7252L13.1231 4.26268C13.4055 4.33836 13.5731 4.62857 13.4974 4.911L9.88182 18.4058ZM6.5 17.6011H6.502L6.50195 17.6031L6.5 17.603V17.6011Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwatchesPalette);
export default __webpack_public_path__ + "static/media/Swatches_Palette.2f77b53114f8c5ab1f02c9e229b2759f.svg";
export { ForwardRef as ReactComponent };